import { Content, GroupField } from '@prismicio/client';
import { PrismicNextLink } from '@prismicio/next';
import { LinkIcon } from '@/assets/icons/PartnerPagesIcons';
import { Simplify } from '../../../../../prismicio-types';
import ImageContent from './ImageContent/ImageContent';
import styles from './Slides.module.scss';

interface Props {
  data: GroupField<
    Simplify<Content.PartnerPagesListSliceDefaultPrimarySlidesItem>
  >;
  activeItem: number;
}

const Slides = ({ data, activeItem }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.list}>
        <ul>
          {data.map((slide, index) => (
            <li className={styles.listElement} key={slide.slide_title}>
              <p
                className={`${styles.title} ${activeItem === index ? styles.visible : ''} ${index === 1 ? styles.oneLineTitle : ''}`}
              >
                {slide.slide_title}
              </p>
              <p
                className={`${styles.subtitle} ${activeItem === index ? styles.visible : ''}`}
              >
                {slide.slide_description}
              </p>
              <PrismicNextLink
                field={slide.button_link}
                className={`${styles.button}  ${activeItem === index ? styles.visible : ''}`}
              >
                <LinkIcon className={styles.icon} />
                {slide.button_text}
              </PrismicNextLink>
            </li>
          ))}
        </ul>
      </div>
      <ImageContent data={data} activeItem={activeItem} />
    </div>
  );
};

export default Slides;
